import React from 'react'
import ReactDOM from 'react-dom/client'
import { Root } from './container/Root'
import "./screens/screens.scss"

ReactDOM
  .createRoot(document.getElementById('app')!)
  .render(
    <React.StrictMode>
      <Root />
    </React.StrictMode>
  )

  